import { render, staticRenderFns } from "./OperaDriverApproval.vue?vue&type=template&id=5d3326af&scoped=true&"
import script from "./OperaDriverApproval.vue?vue&type=script&lang=js&"
export * from "./OperaDriverApproval.vue?vue&type=script&lang=js&"
import style0 from "./OperaDriverApproval.vue?vue&type=style&index=0&id=5d3326af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3326af",
  null
  
)

export default component.exports